import api from 'services/api'
import {
  GET_VEHICLES_LIST,
  DELETE_VEHICLE,
  CREATE_VEHICLE,
  UPDATE_VEHICLE,
  GET_VEHICLE_DETAIL,
} from '../endpoints'

export const getVehiclesList = async (body) => await api.post(GET_VEHICLES_LIST, body)
export const deleteVehicle = async (id) => await api.delete(DELETE_VEHICLE, {data: {id}})

export const submitVehicle = async (values, id) =>
  await api.post(id ? UPDATE_VEHICLE : CREATE_VEHICLE, values)

export const getVehicleDetail = async (id) => await api.get(`${GET_VEHICLE_DETAIL}?id=${id}`)
